import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_SOUCHEINTERNE_SCHEMA_LITERAL = {
    title: 'Schéma SoucheInterne',
    description: 'Décrit une souche interne',
    version: 0,
    keyCompression: false,
    primaryKey: 'DO_SOUCHE_STR',
    type: 'object',
    properties: {
        DO_SOUCHE_STR: { type: 'string', maxLength : 20 },
        DO_SOUCHE: { type: 'number' },
        S_INTITULE: { type: 'string' },
        S_PRINCIPAL_PSITE: { type: 'boolean' },
        S_PRINCIPAL_F: { type: 'boolean' }
    },
    required: [ 'DO_SOUCHE', 'S_INTITULE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_SOUCHEINTERNE_SCHEMA_LITERAL);
export type RxPSoucheInterneDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_SOUCHEINTERNE_SCHEMA: RxJsonSchema<RxPSoucheInterneDocumentType> = P_SOUCHEINTERNE_SCHEMA_LITERAL;
